module.exports = __webpack_public_path__ + "static/media/Alongamento.83d50861.png";